export default __webpack_public_path__ + "static/media/icon-nav-close-hover.7963e9e4.svg";